var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarouselNavigationArrow = function SvgCarouselNavigationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.293 16.293a1 1 0 1 0 1.414 1.414L.293 16.293zM9 9l.707.707a1 1 0 0 0 0-1.414L9 9zM1.707.293A1 1 0 0 0 .293 1.707L1.707.293zm0 17.414 8-8-1.414-1.414-8 8 1.414 1.414zm8-9.414-8-8L.293 1.707l8 8 1.414-1.414z"
  })));
};
export default SvgCarouselNavigationArrow;